import apiClient from '@/plugins/axios'

export default {
  getClientes(filter) {
    return apiClient.post(`cliente/index`, filter)
  },

  getCliente(id) {
    return apiClient.get(`cliente/${id}`)
  },

  getCpfCnpj(cpfcnpj) {
    return apiClient.get(`cliente/getcpfcnpj/${cpfcnpj}`)
  },

  postCliente(cliente) {
    return apiClient.post(`cliente`, { cliente })

  },

  putCliente(id, cliente) {
    return apiClient.put(`cliente/${id}`, { cliente })

  },

  deleteCliente(id) {
    return apiClient.delete(`cliente/${id}`)

  },

  getPagination(url) {
    return apiClient.post(url)
  }

}


// WEBPACK FOOTER //
// ./src/views/Cliente/_services/ClienteService.js